import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ValidateInputService } from '../../../services/validate-input.service';
import { TextInputModel } from './TextInputModel';
import { newLineGreyText } from 'projects/money-movement-ui/src/app/create-request/models/form/FormControlRadio';

@Component({
  standalone: false,
  selector: 'mm-text-input-control',
  templateUrl: './text-input-control.component.html',
  styleUrls: ['./text-input-control.component.scss']
})
export class TextInputControlComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() inputControlModel: TextInputModel;
  @Input() errorMessage: string;
  @Input() lengthWhenCharactersAreHidden: number = 31;
  @Input() placeholder: string = '';
  @Input() useDirty: boolean = false;
  @Output() blur = new EventEmitter();

  constructor(public validationService: ValidateInputService) { }

  ngOnInit(): void {
  }

  get control(): UntypedFormControl | null {
    return this.parentForm.get(this.inputControlModel.controlName) as UntypedFormControl ?? null;
  }

  get hasError(): boolean {
    if (this.useDirty) {
      return (this.control?.dirty && this.control?.invalid) ?? false;
    }
    else {
      return (this.control?.touched && this.control?.invalid) ?? false;
    }
  }

  get setHoverValue(): boolean {
    return (this.control?.value?.length ?? 0) > this.lengthWhenCharactersAreHidden;
  }

  get secondLineGreytext(): newLineGreyText {
    return {
      text: this.inputControlModel.secondLineGreyText ?? ''
    }
  }

  clearField(ctrl: UntypedFormControl | null): void {
    if (ctrl) {
      ctrl.setValue('');
      ctrl.markAsTouched();
    }
  }
}
